import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtilsService, QueryParamsModel} from '../_base/crud';
import {TeamModel} from '../models/team.model';
import {environment} from '../../../environments/environment';
import { OKResponse } from '../_base/crud/models/query-models/query-results.model';
import { ItemsResponse } from '../_base/crud/models/query-models/items-response.model';
import queryString from 'query-string';
import { UserModel } from '../models/user.model';

const API_TEAMS_URL = `${environment.pathToAPI}/api/v1/teams`;

@Injectable()
export class TeamsService {
    constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {
    }

    createTeam(team: TeamModel): Observable<TeamModel> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post<TeamModel>(API_TEAMS_URL, team, {headers: httpHeaders});
    }

    getTeamById(teamId: number): Observable<TeamModel> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.get<TeamModel>(API_TEAMS_URL + `/${teamId}`, {headers: httpHeaders});
    }

    findTeams(queryParams: QueryParamsModel<TeamModel>): Observable<ItemsResponse<TeamModel>> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post<ItemsResponse<TeamModel>>(
            API_TEAMS_URL + '/find',
            queryParams,
            {headers: httpHeaders}
        );
    }

    getTeamUsers(teamId: number, searchText?: string, limit?: number, offset?: number, includeDeleted: boolean = false): Observable<ItemsResponse<UserModel>> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        const query = queryString.stringify({
            searchText,
            offset,
            limit,
            includeDeleted,
        });

        return this.http.get<ItemsResponse<UserModel>>(
            API_TEAMS_URL + `/${teamId}/users?` + query,
            {headers: httpHeaders}
        );
    }

    getProductionUsers(): Observable<UserModel[]> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.get<UserModel[]>(
            API_TEAMS_URL + '/-/users',
            {headers: httpHeaders}
        );
    }

    updateTeam(team: TeamModel): Observable<TeamModel> {
        const httpHeader = this.httpUtils.getHTTPHeaders();
        return this.http.put<TeamModel>(API_TEAMS_URL + '/' + team.id, team, {headers: httpHeader});
    }

    deleteTeam(teamId: number): Observable<OKResponse> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        const url = `${API_TEAMS_URL}/${teamId}`;
        return this.http.delete<OKResponse>(url, {headers: httpHeaders});
    }
}
